const translations = {
  "en": {
    "As of today:%{var0}": "As of today:%{var0}",
    "At close: %{var0}": "At close: %{var0}",
    "Post-market: %{var0}": "Post-market: %{var0}",
    "Pre-market: %{var0}": "Pre-market: %{var0}"
  },
  "zh-tw": {
    "As of today:%{var0}": "今日：%{var0}",
    "At close: %{var0}": "收盤價：%{var0}",
    "Post-market: %{var0}": "盤後：%{var0}",
    "Pre-market: %{var0}": "盤前：%{var0}"
  }
};

export default translations;
